import { images } from '../constants';

const process = [
  {
    id: 1,
    image: images.step1,
    title: 'Lock Assessment',
    content: 'Thorough evaluation of your locksmith needs and requirements to provide tailored solutions.',
  },
  {
    id: 2,
    image: images.step2,
    title: 'Lock Installation',
    content: 'Professional installation of locks and security systems with precision and expertise.',
  },
  {
    id: 3,
    image: images.step3,
    title: 'Key Duplication',
    content: 'Efficient duplication of keys to ensure access control and convenience for our clients.',
  },
  {
    id: 4,
    image: images.step4,
    title: 'Emergency Assistance',
    content: 'Swift and reliable response to emergency lockout situations, ensuring minimal disruption.',
  },
  {
    id: 5,
    image: images.step5,
    title: 'Repair & Maintenance',
    content: 'Professional repair and maintenance services to keep your locks in optimal condition.',
  },
  {
    id: 6,
    image: images.step6,
    title: 'Security Consultation',
    content: 'Comprehensive consultation on security solutions tailored to your specific needs and concerns.',
  },
];

export default process;